import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import FaqForm from "./components/FaqForm";

const FaqIndex = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">FAQ Settings</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> / FAQs
          </h3>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <FaqForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FaqIndex;
